export enum Routes {
  CALENDAR_INDEX = 'calendar.index',
  CALENDAR_SCHEDULE_INDEX = 'calendar.schedule.index',
  CALENDAR_AVAILABILITY_INDEX = 'calendar.availability.index',
  CALENDAR_UNASSIGNED_INDEX = 'calendar.unassigned.index',
  CALENDAR_INDEX_P1_P2 = 'calendar.index.p1.p2',
  RESERVATIONS_INDEX = 'reservations.index',
  RESERVATIONS_INDEX_P1_P2 = 'reservations.index.p1.p2',
  RESERVATION_ROOM_SHOW = 'reservation_room.show',
  RESERVATIONS_DETAIL = 'reservations.detail',
  DASHBOARD_INDEX = 'dashboard.index',
  OFFERS_INDEX = 'offers.index',

  CONTACT_PERSONS_INDEX = 'contact.persons.index',
  CONTACT_PERSONS_INDEX_P1_P2 = 'contact.persons.index.p1.p2',
  GUESTS_INDEX = 'guests.index',
  GUESTS_INDEX_P1_P2 = 'guests.index.p1.p2',
  GUEST_BOOK_INDEX = 'guest.book.index',
  GUEST_EVIDENCE_INDEX = 'guest.evidence.index',
  STATOFFICE_REPORT_CZ_INDEX = 'statoffice.report.cz.index',
  COMPANIES_INDEX = 'companies.index',
  COMPANIES_INDEX_P1_P2 = 'companies.index.p1.p2',
  MAILING_INDEX_AUTOMATED = 'mailing.index.automated',
  MAILING_INDEX_MARKETING = 'mailing.index.marketing',
  MAILING_DETAIL = 'mailing.detail',
  MAILING_INDEX_P1_P2 = 'mailing.index.p1.p2',
  MAILING_INDEX_P1 = 'mailing.index.p1',
  COMMUNICATION_INDEX = 'communication.index',
  BENEFIT_PROGRAM_CARDS_INDEX = 'benefit.program.cards.index',
  BENEFIT_PROGRAM_TURNOVER_INDEX = 'benefit.program.turnover.index',

  /**
   * payments
   */
  INVOICING_DOCUMENTS_INDEX = 'invoicing.documents.index',
  INVOICING_DOCUMENTS_EDIT = 'invoicing.documents.edit',
  INVOICING_DOCUMENTS_INDEX_P1_P2 = 'invoicing.documents.index.p1.p2',

  INVOICING_GIFT_VOUCHERS_INDEX = 'invoicing.gift-vouchers.index',
  INVOICING_GIFT_VOUCHERS_DETAIL = 'invoicing.gift-vouchers.detail',

  INVOICING_PAYMENTS_CASH_BOOK_INDEX = 'invoicing.payments.cashbook.index',
  INVOICING_PAYMENTS_CASH_BOOK_INDEX_P1_P2 = 'invoicing.payments.cashbook.index.p1.p2',
  INVOICING_PAYMENTS_BANK_TRANSFER_INDEX = 'invoicing.payments.banktransfer.index',
  INVOICING_PAYMENTS_BANK_TRANSFER_INDEX_P1_P2 = 'invoicing.payments.banktransfer.index.p1.p2',
  INVOICING_PAYMENTS_TERMINAL_PAYMENT_INDEX = 'invoicing.payments.terminalpayment.index',
  INVOICING_PAYMENTS_TERMINAL_PAYMENT_INDEX_P1_P2 = 'invoicing.payments.terminalpayment.index.p1.p2',
  INVOICING_PAYMENTS_ONLINE_PAYMENT_INDEX = 'invoicing.payments.onlinepayment.index',
  INVOICING_PAYMENTS_ONLINE_PAYMENT_INDEX_P1_P2 = 'invoicing.payments.onlinepayment.index.p1.p2',
  INVOICING_PAYMENTS_COUPON_INDEX = 'invoicing.payments.coupon.index',
  INVOICING_PAYMENTS_COUPON_INDEX_P1_P2 = 'invoicing.payments.coupon.index.p1.p2',

  FOLIO_INDEX_P1_P2 = 'folio.index.p1.p2',
  STOCK_TRANSACTIONS_INDEX = 'stock.transactions.index',
  CLOSURE_INDEX = 'closure.index',
  EXCHANGES_INDEX = 'exchanges.index',
  ACCOUNTING_ASSIGNMENT_INDEX = 'account.assignment.index',
  VAT_CLASSIFICATION_INDEX = 'vat.classification.index',
  PKWIU_INDEX = 'pkwiu.index',
  GTU_CODES_INDEX = 'gtu.codes.index',

  /**
   * reports
   */
  USER_ACTIVITY_INDEX = 'user.activity.index',
  STATISTICS_REPORTS_INDEX = 'statistics.reports.index',
  DAILY_OVERVIEW_INDEX = 'daily.overview.index',
  VISITOR_TAX_REPORT_INDEX = 'visitor.tax.report.index',
  REVIEWS_INDEX = 'reviews.index',
  COMMISSIONS_INDEX = 'commissions.index',
  NTAK_INDEX = 'ntak.index',
  NTAK_REVENUES_INDEX = 'ntak.revenues.index',
  NTAK_EXPENSES_INDEX = 'ntak.expenses.index',
  NTAK_CONNECTION_INDEX = 'ntak.connection.index',
  VISA_STATISTICS_INDEX = 'visa.statistics.index',
  ALFRED_DASHBOARD_INDEX = 'alfred.dashboard.index',
  REPORTS_OCCUPANCY_INDEX = 'reports.occupancy.index',
  REPORTS_RESERVATION_INDEX = 'reports.reservation.index',
  REPORTS_PICKUP_INDEX = 'reports.pickup.index',
  REPORTS_ACCOUNTS_INDEX = 'reports.accounts.index',
  REPORTS_OVERVIEW_INDEX = 'reports.overview.index',
  REPORTS_HOTELGROUP_OVERVIEW_INDEX = 'reports.hotelgroup.overview.index',
  REPORTS_NTAK_KPI_INDEX = 'reports.ntak.kpi.index',
  REPORTS_NTAK_REPORT_INDEX = 'reports.ntak.report.index',

  /**
   * price-list
   */
  PRICE_LIST_INDEX = 'price.list.index',
  MEALS_LIST_INDEX = 'meal.list.index',
  REVENUE_MANAGEMENT_INDEX = 'revenue.management.index',
  EXCHANGE_RATES_INDEX = 'exchange.rates.index',
  EXCHANGE_RATES_INDEX_P1 = 'exchange.rates.index.p1',
  VISITOR_TAX_INDEX = 'visitor.tax.index',
  VISITOR_TAX_INDEX_P1 = 'visitor.tax.index.p1',
  DISCOUNT_LONG_TERM_INDEX = 'discount.long.term.index',
  DISCOUNT_FIRST_MINUTE_INDEX = 'discount.first.minute.index',
  DISCOUNT_LAST_MINUTE_INDEX = 'discount.last.minute.index',
  DISCOUNT_SPECIAL_PRICE_INDEX = 'discount.special.price.index',
  DISCOUNT_COUPONS_INDEX = 'discount.coupons.index',
  SERVICES_INDEX = 'services.index',
  STOCK_INDEX = 'stock.index',
  STAY_PACKAGES_INDEX = 'stay.packages.index',

  /**
   * settings
   */
  HOTEL_GENERAL_INDEX = 'hotel.general.index',
  HOTEL_GENERAL_BANK_ACCOUNTS = 'hotel.general.bankAccounts.index',
  HOTEL_AMENITIES_INDEX = 'hotel.amenities.index',
  HOTEL_PHOTOGALLERIES_INDEX = 'hotel.photogalleries.index',
  HOTEL_GUEST_CATEGORIES_INDEX = 'hotel.guest.categories.index',
  HOTEL_ROOMS_INDEX = 'hotel.rooms.index',
  HOTEL_CONNECTORS_INDEX = 'hotel.connectors.index',
  ONLINE_RESERVATIONS_BOOKING_INDEX = 'online.reservations.booking.index',
  ONLINE_RESERVATIONS_PAYMENTS_INDEX = 'online.reservations.payments.index',
  ONLINE_RESERVATIONS_TERMS_AND_CONDITIONS_INDEX = 'online.reservations.terms.and.conditions.index',
  ONLINE_RESERVATIONS_PRIVACY_POLICY_INDEX = 'online.reservations.privacy.policy.index',
  ONLINE_RESERVATIONS_SYSTEMS_INDEX = 'online.reservations.systems.index',
  WEB_GENERAL_INDEX = 'web.general.index',
  WEB_SECTIONS_INDEX = 'web.sections.index',
  WEB_NEWS_INDEX = 'web.news.index',
  WEB_UPDATE_WP_DATA = 'web.update.wp.data.index',
  WEB_LOGIN_WP_ADMIN = 'web.login.wp.admin.index',
  SETTINGS_ACCOUNTING_DOCUMENTS_INDEX = 'settings.accounting.documents.index',
  SETTINGS_ACCOUNTING_GIFT_VOUCHERS_INDEX = 'settings.accounting.gift-vouchers.index',
  SETTINGS_ACCOUNTING_PAYMENTS_INDEX = 'settings.accounting.payments.index',
  SETTINGS_ACCOUNTING_EXPORTS_SOFTWARE_INDEX = 'settings.accounting.exports.software.index',
  SETTINGS_ACCOUNTING_ACCEPTED_PAYMENTS_TYPES_INDEX = 'settings.accounting.accepted.payments.types.index',
  SETTINGS_ACCOUNTING_ROUNDING_INDEX = 'settings.accounting.rounding.index',
  SETTINGS_ACCOUNTING_EXPORTS_VAT_BREAKDOWN_INDEX = 'settings.accounting.exports.vat.breakdown.index',
  SETTINGS_ALFRED_GENERAL_INDEX = 'settings.alfred.general.index',
  SETTINGS_ALFRED_TRIP_TIPS = 'settings.alfred.tips_for_trips.index',
  SETTINGS_LOCK_SYSTEMS_SETUP = 'settings.lock_systems.setup.index',
  SETTINGS_LOCK_SYSTEMS_SETTINGS = 'settings.lock_systems.settings.index',
  SETTINGS_HOUSEKEEPING_GENERAL_INDEX = 'settings.housekeeping.general.index',
  SETTINGS_HOUSEKEEPING_APP_INDEX = 'settings.housekeeping.app.index',
  SETTINGS_ONLINE_RESERVATIONS_BOOKING_GENERAL = 'settings.online.reservations.booking.general',
  SETTINGS_ONLINE_RESERVATIONS_BOOKING_CONVERSION = 'settings.online.reservations.booking.conversion',
  SETTINGS_ONLINE_RESERVATIONS_BOOKING_FORM_CONFIGURATION = 'settings.online.reservations.booking.form.configuration',
  SETTINGS_GUESTS_AND_COMPANIES_GENERAL_INDEX = 'settings.guest.and.companies.general.index',
  SETTINGS_GUESTS_AND_COMPANIES_GUEST_LABELS_INDEX = 'settings.guest.and.companies.guest.labels.index',
  SETTINGS_GUESTS_AND_COMPANIES_COMPANY_LABELS_INDEX = 'settings.guest.and.companies.company.labels.index',
  SETTINGS_GUESTS_AND_COMPANIES_AGENCY_INDEX = 'settings.guest.and.companies.agency.index',
  SETTINGS_CHANNEL_MANAGER_MY_CONNECTIONS_INDEX = 'settings.channelManager.myConnections.index',
  SETTINGS_CHANNEL_MANAGER_MY_CONNECTIONS_DETAIL = 'settings.channelManager.myConnections.detail',
  SETTINGS_CHANNEL_MANAGER_MY_CONNECTIONS_DETAIL_NEXT = 'settings.channelManager.myConnections.detail.next',
  SETTINGS_CHANNEL_MANAGER_MY_CONNECTIONS_YIELD_PLANET_DETAIL = 'settings.channelManager.myConnections.yieldPlanet.detail',
  SETTINGS_CHANNEL_MANAGER_SERVICE_MAPPING_INDEX = 'settings.channelManager.serviceMapping.index',
  SETTINGS_CHANNEL_MANAGER_MARKETPLACE_INDEX = 'settings.channelManager.marketplace.index',
  SETTINGS_CONNECTED_ROOMS_CONNECTIONS_INDEX = 'settings.connectedRooms.connections.index',
  SETTINGS_CONNECTED_ROOMS_GENERAL_INDEX = 'settings.connectedRooms.general.index',
  SETTINGS_OFFER_INDEX = 'settings.offer.index',
  SETTINGS_RESERVATIONS_GENERAL = 'settings.reservations.general.index',
  SETTINGS_RESERVATIONS_FOLIO = 'settings.reservations.folio.index',
  SETTINGS_RESERVATIONS_VOUCHER = 'settings.reservations.voucher.index',
  SETTINGS_HOTEL_EMAIL = 'settings.hotel.email.index',
  SETTINGS_HOTEL_WHATSAPP = 'settings.hotel.whatsapp.index',
  SETTINGS_HOTEL_REPORTS_CSU = 'settings.hotel.reports.csu.index',
  SETTINGS_NOTIFICATIONS_RESERVATION = 'settings.notifications.reservation.index',
  SETTINGS_DASHBOARD_INDEX = 'settings.dashboard.index',

  USERS_INDEX = 'users.index',
  USERS_DETAIL = 'users.detail',
  ROLES_INDEX = 'roles.index',
  DESCRIPTIONS_INDEX = 'descriptions.index',
  MARKET_CODES_INDEX = 'market.codes.index',
  SIGNIFICANT_DATES_INDEX = 'significant.dates.index',
  SYSTEM_RESERVATION_INDEX = 'system.reservation.index',
  SYSTEM_VOUCHER_INDEX = 'system.voucher.index',
  SYSTEM_HOTEL_ACCOUNT_INDEX = 'system.hotel.account.index',
  SYSTEM_REPORTS_INDEX = 'system.reports.index',
  SYSTEM_EMAIL_INDEX = 'system.email.index',

  /**
   * housekeeping
   */
  HOUSEKEEPING_INDEX = 'housekeeping.index',
  DEFECTS_INDEX = 'defects.index',
  TASKS_INDEX = 'tasks.index',
  TASK_TEMPLATES_INDEX = 'task.templates.index',

  /**
   * help
   */
  HELP_INVOICES_INDEX = 'help.invoices.index',
  HELP_MANUAL_INDEX = 'help.manual.index',
  HELP_USER_TIPS_INDEX = 'help.user.tips.index',
  HELP_FEEDBACK_INDEX = 'help.feedback.index',
  HELP_DEMO_INDEX = 'help.demo.index',

  /**
   * general
   */
  GENERAL_SELECT_PROPERTY = 'general.selectProperty.index',
  GENERAL_NO_OBJECT_ROOMS = 'general.noObjectRooms.index',
  GENERAL_NOT_FOUND = 'general.notFound.index',

  /**
   * entrypoint
   */
  ENTRYPOINT_LOGIN_INDEX = 'entrypoint.login.index',
  ENTRYPOINT_LOGOUT_INDEX = 'entrypoint.logout.index',

  /**
   * self-service bar
   */
  SELF_SERVICE_BAR_INDEX = 'selfServiceBar.index',
  SELF_SERVICE_BAR_QR_PREVIEW_LOAD_PDF = 'selfServiceBar.qr.preview.load.pdf',

  /**
   * pos
   */
  POS_INDEX = 'pos.index',

  /**
   * ai
   */
  AI_INDEX = 'ai.index',
  ALFRED_AI_INDEX = 'alfred.ai.index',
}
